/**
 * Auto-generated Atom and Entity Infos
 */

import { CONTEXT_KEY } from "@atoms/atom-types";
import { DefaultAtoms, DefaultEntities, NotificationAtoms } from "@atoms/atom-types";
import { Atoms } from "../enums/atoms";
import { Entities } from "../enums/entities";
import { UserState } from "@atoms/atom-types";

// Extended atom infos with default values
export const atomInfosExtended = {
  [Atoms.AdditionalArticleInfo]: {
    entityType: Entities.AdditionalArticle,
    currentSchemaVersion: 1,
    defaultValues: {
      "articleNumber": "",
      "deleted": false,
      "name": "",
      "purchasePrice": null,
      "unit": "Piece",
      "weight": null,
      "workUnits": 0,
    },
  },
  [Atoms.ImportProtocol]: {
    entityType: Entities.ImportProcess,
  },
  [Atoms.OrderInfo]: {
    entityType: Entities.Order,
  },
  [Atoms.OrderPositions]: {
    entityType: Entities.Order,
  },
  [Atoms.PositionInfo]: {
    entityType: Entities.Position,
    currentSchemaVersion: 3,
    defaultValues: {
      "additionalArticles": null,
      "amount": 1,
      "articleId": null,
      "claimee": null,
      "commodityGroup": "",
      "compartments": null,
      "createdAt": new Date(),
      "customer": "",
      "deleted": false,
      "description": "",
      "division": "",
      "importReport": null,
      "manualChanges": null,
      "manufacturer": "",
      "megaCaseInfo": null,
      "metaInfo": null,
      "model": "",
      "orderNumber": "",
      "price": null,
      "priceParameters": null,
      "reference": "",
      "requiredPresets": () => [],
      "source": "",
      "userDefinedOptions": null,
      "variant": "",
    },
    requireExplicitWritePermissionFields: ["createdAt", "source"],
  },
  [Atoms.PositionMeta]: {
    entityType: Entities.Position,
    defaultValues: {
      "previewImageUrl": null,
    },
  },
  [Atoms.PresetInfo]: {
    entityType: Entities.Preset,
    currentSchemaVersion: 1,
    defaultValues: {
      "category": "",
      "data": {},
      "deleted": false,
      "name": "",
      "productType": "",
      "tags": undefined,
    },
    requireExplicitWritePermissionFields: ["tags"],
    requireExplicitWritePermissionCustomPermissions: {
      "tags": "custom:ManageTaggedPresets",
    },
  },
  [Atoms.PresetList]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.PriceDataInfo]: {
    entityType: Entities.PriceData,
    defaultValues: {
      "countRivets": 0,
      "customerName": "",
      "description": "",
      "partCategory": "",
      "pricePurchase": 0,
      "unit": "Unknown",
      "weightGramms": 0,
      "workingTimeMinutes": 0,
    },
  },
  [Atoms.PriceParameters]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.RecentImports]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.UserOptionInfo]: {
    entityType: Entities.UserOption,
    currentSchemaVersion: 1,
    defaultValues: {
      "aliases": undefined,
      "deleted": false,
      "description": "",
      "kind": "",
      "meshes": undefined,
      "name": "",
    },
  },
  [Atoms.UserOptionsList]: {
    entityType: DefaultEntities.Global,
  },
  [DefaultAtoms.ApiTokens]: {
    entityType: DefaultEntities.User,
  },
  [DefaultAtoms.FrontendConfig]: {
    entityType: DefaultEntities.Global,
  },
  [DefaultAtoms.PersonalUserData]: {
    entityType: DefaultEntities.User,
    defaultValues: {
      "authProviderId": null,
      "emailVerified": false,
      "imageUrl": "",
      "isAdmin": false,
      "permissions": [],
      "serviceAccount": false,
      "state": UserState.Active,
    },
    requireExplicitWritePermissionFields: ["authProviderId", "emailVerified", "isAdmin", "serviceAccount", "state"],
    requireExplicitWritePermissionCustomPermissions: {
      "authProviderId": "custom:UpdateProtectedUserFields",
      "emailVerified": "custom:UpdateProtectedUserFields",
      "isAdmin": "custom:UpdateProtectedUserFields",
      "serviceAccount": "custom:UpdateProtectedUserFields",
      "state": "custom:UpdateProtectedUserFields",
    },
  },
  [NotificationAtoms.UserNotifications]: {
    entityType: DefaultEntities.User,
    defaultValues: {
      "actionLabel": null,
      "actionUrl": null,
      "createdAt": () => new Date(),
      "priority": "normal",
      "read": false,
      "readAt": null,
    },
  },
};

export const entityInfos = {
  [DefaultEntities.Global]: {
    validContexts: [
      []
    ],
    pathTemplates: [
      `/`
    ],
    urlTemplate: "/",
  },
  [DefaultEntities.User]: {
    validContexts: [
      [CONTEXT_KEY(DefaultEntities.User)]
    ],
    pathTemplates: [
      `/User/<User>`
    ],
    urlTemplate: "/:user",
  },
  [Entities.AdditionalArticle]: {
    validContexts: [
      [CONTEXT_KEY(Entities.AdditionalArticle)]
    ],
    pathTemplates: [
      `/AdditionalArticle/<AdditionalArticle>`
    ],
    urlTemplate: "/:additionalArticle",
  },
  [Entities.ImportProcess]: {
    validContexts: [
      [CONTEXT_KEY(Entities.ImportProcess)]
    ],
    pathTemplates: [
      `/ImportProcess/<ImportProcess>`
    ],
    urlTemplate: "/:importProcess",
  },
  [Entities.Order]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Order)]
    ],
    pathTemplates: [
      `/Order/<Order>`
    ],
    urlTemplate: "/:order",
  },
  [Entities.Position]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Position)]
    ],
    pathTemplates: [
      `/Position/<Position>`
    ],
    urlTemplate: "/pos/:position",
  },
  [Entities.Preset]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Preset)]
    ],
    pathTemplates: [
      `/Preset/<Preset>`
    ],
    urlTemplate: "/:preset",
  },
  [Entities.PriceData]: {
    validContexts: [
      [CONTEXT_KEY(Entities.PriceData)]
    ],
    pathTemplates: [
      `/PriceData/<PriceData>`
    ],
    urlTemplate: "/:priceData",
  },
  [Entities.UserOption]: {
    validContexts: [
      [CONTEXT_KEY(Entities.UserOption)]
    ],
    pathTemplates: [
      `/UserOption/<UserOption>`
    ],
    urlTemplate: "/:userOption",
  },
};

export function getPathesForEntity<T extends keyof typeof entityInfos>(entity: T, name: string): string[] {
  const info = entityInfos[entity];
  return info?.pathTemplates.map((template: string) => `${template}/${name}`) ?? [];
}